import { createTheme } from '@mui/material/styles'
import './scss/style.scss'
// assets
import colors from './scss/_themes-vars.module.scss'

// project imports
import componentStyleOverrides from './compStyleOverride'
import themePalette from './palette'
import themeTypography from './typography'

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = () => {
  const color = colors

  const themeOption = {
    colors: color,
    heading: color.grey900,
    paper: color.paper,
    backgroundDefault: color.paper,
    background: color.primaryLight,
    darkTextPrimary: color.grey700,
    darkTextSecondary: color.grey500,
    textDark: color.grey900,
    menuSelected: color.paper,
    menuSelectedBack: color.menuBackgroundPrimary,
    divider: color.grey200
  }

  const themeOptions: any = {
    direction: 'ltr',
    palette: themePalette(themeOption),

    mixins: {
      toolbar: {
        minHeight: '48px',
        // padding: '16px',
        '@media (min-width: 600px)': {
          minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption),
    components: componentStyleOverrides(themeOption)
  }

  const themes = createTheme(themeOptions)

  return themes
}

export default theme
